import React from 'react'
import { IconButton, TextField, Dialog, DialogContent, DialogTitle, List, ListItem, ListItemButton, ListItemText, Divider } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useGlobalState } from 'state'
import { getHeartrailsAddresses } from 'common/utils'

type Address = {
  name: string
  lat: number
  lng: number
}

export const AddressSearchControl = () => {
  const state = useGlobalState()
  const [keyword, setKeyword] = React.useState<string>('')
  const [addresses, setAddresses] = React.useState<Address[]>([])

  const searchKeyword = async () => {
    const targets = await getHeartrailsAddresses(keyword)
    setAddresses(targets)
  }

  const selectAddress = (address: Address) => {
    if (!state.mapbox) return
    state.mapbox.flyTo({
      center: [address.lng, address.lat],
      zoom: 15
    })
    setAddresses([])
  }

  return (
    <>
      <TextField
        size='small'
        id='address-search'
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        InputProps={{ endAdornment: <IconButton color="inherit" onClick={searchKeyword}><SearchIcon /></IconButton> }}
        sx={{ width: 180}}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
            searchKeyword()
          }
        }}
      />
      <Dialog open={addresses.length > 0} onClose={() => setAddresses([])}>
        <DialogTitle>住所検索</DialogTitle>
        <DialogContent sx={{px: 1}}>
          <List sx={{maxHeight: '60vh'}}>
            {
              addresses.map((address, index) => (
                <>
                  <ListItem key={index} onClick={() => selectAddress(address)} disablePadding>
                    <ListItemButton sx={{ p: '4px' }}>
                      <ListItemText sx={{m: 0}} primary={address.name} />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </>
              ))
            }
          </List>
        </DialogContent>
      </Dialog>
    </>
  )
}
